import { render, staticRenderFns } from "./ConfigFlowHistorical.vue?vue&type=template&id=b697b13c&"
import script from "./ConfigFlowHistorical.vue?vue&type=script&lang=js&"
export * from "./ConfigFlowHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports